import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-dark-950 via-dark-900 to-dark-800 text-gray-300 py-16">
      <Helmet>
        <title>Terms of Service - LeadGen AI</title>
        <meta name="description" content="Read LeadGen AI terms of service. Understand the rules and guidelines for using our lead generation platform." />
        <link rel="canonical" href="https://leadgenai.in/terms" />
      </Helmet>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Terms and Conditions</h1>
          <p className="text-gray-400">Last updated: June 2025</p>
        </div>

        <div className="space-y-10 bg-zinc-900/50 p-8 md:p-12 rounded-2xl border border-white/10/60 shadow-xl backdrop-blur-sm prose prose-invert prose-slate max-w-none">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p>By accessing and using LeadGen AI ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by these terms, please do not use this service.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Description of Service</h2>
            <p>LeadGen AI is a B2B lead generation tool that utilizes public APIs and web scraping techniques to aggregate publicly available business data (such as names, addresses, phone numbers, and emails) into an organized format for your business outreach.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. User Accounts</h2>
            <p>To use our service, you must create an account. You must be at least 18 years old. You are responsible for maintaining the confidentiality of your account password and for all activities that occur under your account. You must provide accurate and complete information during registration.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Subscription Plans & Billing</h2>
            <p>We offer Basic (Free), Standard, and Premium subscription plans. Paid plans are billed on a recurring basis. Prices are subject to change with advance notice. Failure to pay may result in immediate suspension or termination of your account.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1 ml-4 block">
              <li>Use the Service for any illegal or unauthorized purpose</li>
              <li>Employ bots or automated scripts to scrape our platform's data</li>
              <li>Resell the Service or provide it as a white-labeled product without explicit permission</li>
              <li>Spam or harass the businesses found through our Service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Data Accuracy</h2>
            <p>While we use advanced algorithms and reliable APIs to gather data, we do not guarantee that the information provided is 100% accurate, complete, or up-to-date. You use the data at your own risk and discretion.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Intellectual Property</h2>
            <p>All content, design, code, and branding of LeadGen AI is our exclusive intellectual property. You may not copy, modify, or distribute any part of our platform without prior written consent.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Limitation of Liability</h2>
            <p>LeadGen AI shall not be liable for any indirect, incidental, special, consequential or punitive damages, including loss of profits, data, or goodwill, resulting from your access to or use of the Service.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Termination</h2>
            <p>We reserve the right to suspend or terminate your account at any time, without notice, for conduct that we believe violates these Terms or is harmful to other users of the Service, us, or third parties.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Governing Law</h2>
            <p>These terms shall be governed by and defined following the laws of India. LeadGen AI and yourself irrevocably consent that the courts of India shall have exclusive jurisdiction to resolve any dispute.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Contact</h2>
            <p>If you have any questions regarding these Terms, please reach out to us at:</p>
            <p className="mt-2 text-blue-400">
              <Link to="/contact" className="hover:underline">Contact Legal Team</Link>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
